var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mbg text-center",staticStyle:{"padding-top":"12px","width":"55px","min-width":"55px","font-size":"21px"}},[_c('i',{staticClass:"fa fa-solid fa-bars cursor-pointer",on:{"click":_vm.menu}})])
}
var staticRenderFns = []

export { render, staticRenderFns }